import Title from "common/Typography/Title";
import { getAllSelectedDisplay } from "@shared/features/filters/utils";
import { FilterType } from "@shared/types";
import Popover from "common/Popover/Popover";
import PriceRangeFiltersSection from "common/Filters/PriceRangeFiltersSection";
import { FilterSectionData } from "@shared/features/filters/types";
import { MobileResetButton, StyledInput } from "common/Filters/common/styles";
import { useBottomNavigator } from "utils/hooks/misc";
import React from "react";
import BottomDrawer from "common/Drawers/BottomDrawer";

const PriceRangeFilterChips = <T extends FilterType.PRICE_RANGE>({
  title,
  options,
  value,
  onChange,
  isSingleRowView,
  selectAll,
  resetButtonData,
  ...props
}: FilterSectionData<T>) => {
  const bottomNavigatorData = useBottomNavigator();
  const isBottomNavigator = bottomNavigatorData.baseShouldDisplay;
  const allSelected =
    options[0] === value[0] && options[options.length - 1] === value[1];

  const content = (
    <div style={{ width: isBottomNavigator ? "100%" : 300 }}>
      {!isBottomNavigator && <Title level={4}>{title}</Title>}
      <PriceRangeFiltersSection<T>
        title={title}
        options={options}
        value={value}
        onChange={onChange}
        selectAll={selectAll}
        resetButtonData={resetButtonData}
        {...props}
      />
      {isBottomNavigator && (
        <MobileResetButton
          onClick={resetButtonData.onClick}
          style={{ marginTop: 24 }}
          disabled={allSelected}
        >
          {resetButtonData.resetText}
        </MobileResetButton>
      )}
    </div>
  );

  const placeholder = getAllSelectedDisplay(title, isSingleRowView, true);

  const getDisplayedValue = () => {
    if (value[0] === value[1]) {
      return value[0] ? "$".repeat(value[0] ?? 0) : "0";
    } else {
      return `${value[0] ? "$".repeat(value[0] ?? 0) : "0"}-${"$".repeat(
        value[1] ?? 0
      )}`;
    }
  };

  let inputValue: string | undefined;
  if (!allSelected && options.length && value.length) {
    inputValue = getDisplayedValue();
  }

  const input = (
    <StyledInput
      value={inputValue}
      placeholder={placeholder}
      allowClear={!isBottomNavigator}
      readOnly={true}
      style={{ minWidth: 140 }}
      $showClear={!!inputValue}
      $isSingleRowView={isSingleRowView}
      onChange={(value) => {
        if (!value.target.value) {
          selectAll();
        }
      }}
      $hasValue={!!inputValue}
    />
  );

  if (isBottomNavigator) {
    return (
      <BottomDrawer title={title} triggerElement={input} content={content} />
    );
  }

  return (
    <Popover content={content} trigger={["click"]} placement="bottom">
      {input}
    </Popover>
  );
};

export default PriceRangeFilterChips;
